import React from "react";
import { Container } from "semantic-ui-react";
import { GamesBoard } from "./components";

export const Frontpage = () => {
  return (
    <Container>
      <GamesBoard />
    </Container>
  );
};
